module.exports = __webpack_public_path__ + "img/ipad-en-12.4b6f320.jpg";